"use strict";
/**
 * @file Created on Wed Aug 12 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomas Leity
 */


var DummyWindowSimulationParamsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(DummyWindowSimulationParamsConverter, _DataObjectConverter_);

  function DummyWindowSimulationParamsConverter() {
    _classCallCheck(this, DummyWindowSimulationParamsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowSimulationParamsConverter).apply(this, arguments));
  }

  return DummyWindowSimulationParamsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.DummyWindowSimulationParamsConverter = DummyWindowSimulationParamsConverter;